// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"40a4f21d","243":"97a83acd","456":"fb911f0b","688":"55495871","741":"bc6aec08","995":"cacd58dc"}[chunkId] + ".chunk.js";
};